/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/Content/Heading/Title"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Similar persons found"
 level="h4"
/>
{children}
</React.Fragment>)
}